import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./portal.css";
import { Join } from "./screens/Join";
import { Proposal } from "./screens/Proposal";

const path = location.pathname;
const proposal = /^\/proposal\/([A-Za-z0-9_-]{16,80})$/.exec(path);
createRoot(document.getElementById("root")!).render(
  <StrictMode>{proposal ? <Proposal token={proposal[1]!} /> : path === "/join" ? <Join /> : <App />}</StrictMode>,
);
